import * as contactApis from './api.contact'
import * as mcpApis from './api.mcp'
import * as acpApis from './api.acp'

export * from './api'

export const contact = { ...contactApis }
export const mcp = { ...mcpApis }
export const acp = { ...acpApis }
